module.exports = __webpack_public_path__ + "brand-img.svg?435145af2a07befaeb867d8eef091d95";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-img.svg
// module id = 170
// module chunks = 0